// DS: i6.24
import React from 'react';
import IconWrap, { Props } from '../../IconWrap';

const StudioGallery: React.FC<Props> = props => {
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3.1 1.5h11a1 1 0 0 1 1 1v11h-1.5V3.4a.4.4 0 0 0-.4-.4H3.1zm-1 3a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1zm3 3.25a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0m1.75 1.87a.5.5 0 0 1 .67.02l2.93 2.86c.1.09.15.22.15.35v.65a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.33-.88z"
          clipRule="evenodd"
        />
      </svg>
    </IconWrap>
  );
};
StudioGallery.displayName = 'StudioGallery';

export default StudioGallery;
